// Complete Icon Mappings for All Icon Libraries

// Lucide Icons (existing)
import { 
  Wallet as LucideWallet, 
  Mail as LucideMail, 
  Music as LucideMusic, 
  FileText as LucideFileText, 
  HardDrive as LucideHardDrive, 
  Globe as LucideGlobe, 
  Terminal as LucideTerminal, 
  Settings as LucideSettings, 
  Calendar as LucideCalendar, 
  Search as LucideSearch, 
  TrendingUp as LucideTrendingUp, 
  Briefcase as LucideBriefcase, 
  Table as LucideTable, 
  Share2 as LucideShare2,
  DollarSign as LucideDollarSign,
  Store as LucideStore,
  Code2 as LucideCode2,
  Video as LucideVideo,
  Camera as LucideCamera,
  MapPin as LucideMapPin,
  MessageCircle as LucideMessageCircle,
  Users as LucideUsers,
  Gamepad2 as LucideGamepad2,
  BookOpen as LucideBookOpen,
  Box as LucideBox,
  Palette as LucidePalette,
  GraduationCap as LucideGraduationCap,
  UserCheck as LucideUserCheck,
  Circle as LucideCircle,
  Monitor as LucideMonitor,
  Edit as LucideEdit
} from 'lucide-react'

// React Icons (Material Design) - existing
import { 
  MdAccountBalanceWallet,
  MdEmail,
  MdLibraryMusic,
  MdDescription,
  MdStorage,
  MdLanguage,
  MdTerminal,
  MdSettings,
  MdCalendarToday,
  MdSearch,
  MdTrendingUp,
  MdWork,
  MdTableChart,
  MdShare,
  MdAttachMoney,
  MdStore,
  MdCode,
  MdShowChart,
  MdVideoLibrary,
  MdPhotoCamera,
  MdLocationOn,
  MdChat,
  MdGroup,
  MdSportsEsports,
  MdMenuBook,
  MdViewInAr,
  MdPalette,
  MdSchool,
  MdVerifiedUser,
  MdCircle,
  MdMonitor
} from 'react-icons/md'

// Tabler Icons
import {
  IconWallet as TablerWallet,
  IconMail as TablerMail,
  IconMusic as TablerMusic,
  IconFileText as TablerFileText,
  IconDatabase as TablerDatabase,
  IconWorld as TablerWorld,
  IconTerminal2 as TablerTerminal,
  IconSettings as TablerSettings,
  IconCalendar as TablerCalendar,
  IconSearch as TablerSearch,
  IconTrendingUp as TablerTrendingUp,
  IconBriefcase as TablerBriefcase,
  IconTable as TablerTable,
  IconShare as TablerShare,
  IconCurrencyDollar as TablerCurrencyDollar,
  IconBuildingStore as TablerStore,
  IconCode as TablerCode,
  IconChartLine as TablerChartLine,
  IconVideo as TablerVideo,
  IconCamera as TablerCamera,
  IconMapPin as TablerMapPin,
  IconMessage as TablerMessage,
  IconUsers as TablerUsers,
  IconDeviceGamepad as TablerGamepad,
  IconBook as TablerBook,
  IconBox as TablerBox,
  IconPalette as TablerPalette,
  IconSchool as TablerSchool,
  IconUserCheck as TablerUserCheck,
  IconCircle as TablerCircle
} from '@tabler/icons-react'

// Hero Icons
import {
  WalletIcon as HeroWallet,
  EnvelopeIcon as HeroMail,
  MusicalNoteIcon as HeroMusic,
  DocumentTextIcon as HeroFileText,
  ServerIcon as HeroDatabase,
  GlobeAltIcon as HeroGlobe,
  CommandLineIcon as HeroTerminal,
  Cog6ToothIcon as HeroSettings,
  CalendarIcon as HeroCalendar,
  MagnifyingGlassIcon as HeroSearch,
  ArrowTrendingUpIcon as HeroTrendingUp,
  BriefcaseIcon as HeroBriefcase,
  TableCellsIcon as HeroTable,
  ShareIcon as HeroShare,
  CurrencyDollarIcon as HeroCurrencyDollar,
  BuildingStorefrontIcon as HeroStore,
  CodeBracketIcon as HeroCode,
  ChartBarIcon as HeroChartBar,
  VideoCameraIcon as HeroVideo,
  CameraIcon as HeroCamera,
  MapPinIcon as HeroMapPin,
  ChatBubbleLeftRightIcon as HeroMessage,
  UserGroupIcon as HeroUsers,
  PuzzlePieceIcon as HeroGamepad,
  BookOpenIcon as HeroBookOpen,
  CubeIcon as HeroBox,
  PaintBrushIcon as HeroPalette,
  AcademicCapIcon as HeroAcademicCap,
  UserPlusIcon as HeroUserCheck,
  EllipsisHorizontalCircleIcon as HeroCircle
} from '@heroicons/react/24/outline'

// Feather Icons
import {
  CreditCard as FeatherWallet, // Using CreditCard instead of Wallet
  Mail as FeatherMail,
  Music as FeatherMusic,
  FileText as FeatherFileText,
  HardDrive as FeatherHardDrive,
  Globe as FeatherGlobe,
  Terminal as FeatherTerminal,
  Settings as FeatherSettings,
  Calendar as FeatherCalendar,
  Search as FeatherSearch,
  TrendingUp as FeatherTrendingUp,
  Briefcase as FeatherBriefcase,
  Grid as FeatherTable,
  Share2 as FeatherShare,
  DollarSign as FeatherDollarSign,
  ShoppingBag as FeatherStore,
  Code as FeatherCode,
  Activity as FeatherActivity,
  Video as FeatherVideo,
  Camera as FeatherCamera,
  MapPin as FeatherMapPin,
  MessageCircle as FeatherMessageCircle,
  Users as FeatherUsers,
  Cpu as FeatherGamepad,
  BookOpen as FeatherBookOpen,
  Box as FeatherBox,
  Droplet as FeatherPalette,
  Award as FeatherAward,
  CheckCircle as FeatherUserCheck, // Using CheckCircle instead of UserCheck
  Circle as FeatherCircle
} from 'react-feather'

// Phosphor Icons
import {
  Wallet as PhosphorWallet,
  Envelope as PhosphorMail,
  MusicNotes as PhosphorMusic,
  FileText as PhosphorFileText,
  HardDrives as PhosphorHardDrives,
  Globe as PhosphorGlobe,
  Terminal as PhosphorTerminal,
  Gear as PhosphorSettings,
  Calendar as PhosphorCalendar,
  MagnifyingGlass as PhosphorSearch,
  TrendUp as PhosphorTrendingUp,
  Briefcase as PhosphorBriefcase,
  Table as PhosphorTable,
  Share as PhosphorShare,
  CurrencyDollar as PhosphorCurrencyDollar,
  Storefront as PhosphorStore,
  Code as PhosphorCode,
  ChartLine as PhosphorChartLine,
  VideoCamera as PhosphorVideo,
  Camera as PhosphorCamera,
  MapPin as PhosphorMapPin,
  Chat as PhosphorChat,
  Users as PhosphorUsers,
  GameController as PhosphorGamepad,
  BookOpen as PhosphorBookOpen,
  Cube as PhosphorBox,
  Palette as PhosphorPalette,
  GraduationCap as PhosphorGraduationCap,
  UserPlus as PhosphorUserCheck,
  Circle as PhosphorCircle
} from 'phosphor-react'

// Remix Icons - Using react-icons/ri for better compatibility
import {
  RiWalletLine,
  RiMailLine,
  RiMusic2Line,
  RiFileTextLine,
  RiHardDriveLine,
  RiGlobalLine,
  RiTerminalLine,
  RiSettings3Line,
  RiCalendarLine,
  RiSearchLine,
  RiLineChartLine,
  RiBriefcaseLine,
  RiTableLine,
  RiShareLine,
  RiMoneyDollarCircleLine,
  RiStoreLine,
  RiCodeLine,
  RiBarChartLine,
  RiVideoLine,
  RiCameraLine,
  RiMapPinLine,
  RiMessage2Line,
  RiGroupLine,
  RiGamepadLine,
  RiBookOpenLine,
  RiInboxLine,
  RiPaletteLine,
  RiGraduationCapLine,
  RiUserAddLine,
  RiCircleLine
} from 'react-icons/ri'

// Bootstrap Icons - Using react-icons/bs for better compatibility  
import {
  BsWallet,
  BsEnvelope,
  BsMusicNote,
  BsFileText,
  BsHddStack,
  BsGlobe,
  BsTerminal,
  BsGear,
  BsCalendar,
  BsSearch,
  BsGraphUp,
  BsBriefcase,
  BsTable,
  BsShare,
  BsCurrencyDollar,
  BsShop,
  BsCode,
  BsBarChart,
  BsCameraVideo,
  BsCamera,
  BsGeoAlt,
  BsChatDots,
  BsPeople,
  BsController,
  BsBook,
  BsBox,
  BsPalette,
  BsMortarboard,
  BsPersonCheck,
  BsCircle
} from 'react-icons/bs'

export interface CompleteIconMapping {
  lucide: any
  'react-icons': any
  tabler: any
  heroicons: any
  feather: any
  phosphor: any
  remix: any
  bootstrap: any
}

export const completeIconMappings: { [key: string]: CompleteIconMapping } = {
  // Bitcoin app icons
  'bitcoin-wallet': { 
    lucide: LucideWallet, 
    'react-icons': MdAccountBalanceWallet,
    tabler: TablerWallet,
    heroicons: HeroWallet,
    feather: FeatherWallet,
    phosphor: PhosphorWallet,
    remix: RiWalletLine,
    bootstrap: BsWallet
  },
  'bitcoin-email': { 
    lucide: LucideMail, 
    'react-icons': MdEmail,
    tabler: TablerMail,
    heroicons: HeroMail,
    feather: FeatherMail,
    phosphor: PhosphorMail,
    remix: RiMailLine,
    bootstrap: BsEnvelope
  },
  'bitcoin-music': { 
    lucide: LucideMusic, 
    'react-icons': MdLibraryMusic,
    tabler: TablerMusic,
    heroicons: HeroMusic,
    feather: FeatherMusic,
    phosphor: PhosphorMusic,
    remix: RiMusic2Line,
    bootstrap: BsMusicNote
  },
  'bitcoin-writer': { 
    lucide: LucideFileText, 
    'react-icons': MdDescription,
    tabler: TablerFileText,
    heroicons: HeroFileText,
    feather: FeatherFileText,
    phosphor: PhosphorFileText,
    remix: RiFileTextLine,
    bootstrap: BsFileText
  },
  'bitcoin-code': { 
    lucide: LucideCode2, 
    'react-icons': MdCode,
    tabler: TablerCode,
    heroicons: HeroCode,
    feather: FeatherCode,
    phosphor: PhosphorCode,
    remix: RiCodeLine,
    bootstrap: BsCode
  },
  'bitcoin-drive': { 
    lucide: LucideHardDrive, 
    'react-icons': MdStorage,
    tabler: TablerDatabase,
    heroicons: HeroDatabase,
    feather: FeatherHardDrive,
    phosphor: PhosphorHardDrives,
    remix: RiHardDriveLine,
    bootstrap: BsHddStack
  },
  'bitcoin-calendar': { 
    lucide: LucideCalendar, 
    'react-icons': MdCalendarToday,
    tabler: TablerCalendar,
    heroicons: HeroCalendar,
    feather: FeatherCalendar,
    phosphor: PhosphorCalendar,
    remix: RiCalendarLine,
    bootstrap: BsCalendar
  },
  'bitcoin-exchange': { 
    lucide: LucideTrendingUp, 
    'react-icons': MdShowChart,
    tabler: TablerChartLine,
    heroicons: HeroChartBar,
    feather: FeatherActivity,
    phosphor: PhosphorChartLine,
    remix: RiLineChartLine,
    bootstrap: BsGraphUp
  },
  'bitcoin-search': { 
    lucide: LucideSearch, 
    'react-icons': MdSearch,
    tabler: TablerSearch,
    heroicons: HeroSearch,
    feather: FeatherSearch,
    phosphor: PhosphorSearch,
    remix: RiSearchLine,
    bootstrap: BsSearch
  },
  'bitcoin-spreadsheet': { 
    lucide: LucideTable, 
    'react-icons': MdTableChart,
    tabler: TablerTable,
    heroicons: HeroTable,
    feather: FeatherTable,
    phosphor: PhosphorTable,
    remix: RiTableLine,
    bootstrap: BsTable
  },
  'bitcoin-video': { 
    lucide: LucideVideo, 
    'react-icons': MdVideoLibrary,
    tabler: TablerVideo,
    heroicons: HeroVideo,
    feather: FeatherVideo,
    phosphor: PhosphorVideo,
    remix: RiVideoLine,
    bootstrap: BsCameraVideo
  },
  'bitcoin-photos': { 
    lucide: LucideCamera, 
    'react-icons': MdPhotoCamera,
    tabler: TablerCamera,
    heroicons: HeroCamera,
    feather: FeatherCamera,
    phosphor: PhosphorCamera,
    remix: RiCameraLine,
    bootstrap: BsCamera
  },
  'bitcoin-maps': { 
    lucide: LucideMapPin, 
    'react-icons': MdLocationOn,
    tabler: TablerMapPin,
    heroicons: HeroMapPin,
    feather: FeatherMapPin,
    phosphor: PhosphorMapPin,
    remix: RiMapPinLine,
    bootstrap: BsGeoAlt
  },
  'bitcoin-chat': { 
    lucide: LucideMessageCircle, 
    'react-icons': MdChat,
    tabler: TablerMessage,
    heroicons: HeroMessage,
    feather: FeatherMessageCircle,
    phosphor: PhosphorChat,
    remix: RiMessage2Line,
    bootstrap: BsChatDots
  },
  'bitcoin-social': { 
    lucide: LucideUsers, 
    'react-icons': MdGroup,
    tabler: TablerUsers,
    heroicons: HeroUsers,
    feather: FeatherUsers,
    phosphor: PhosphorUsers,
    remix: RiGroupLine,
    bootstrap: BsPeople
  },
  'bitcoin-games': { 
    lucide: LucideGamepad2, 
    'react-icons': MdSportsEsports,
    tabler: TablerGamepad,
    heroicons: HeroGamepad,
    feather: FeatherGamepad,
    phosphor: PhosphorGamepad,
    remix: RiGamepadLine,
    bootstrap: BsController
  },
  'bitcoin-books': { 
    lucide: LucideBookOpen, 
    'react-icons': MdMenuBook,
    tabler: TablerBook,
    heroicons: HeroBookOpen,
    feather: FeatherBookOpen,
    phosphor: PhosphorBookOpen,
    remix: RiBookOpenLine,
    bootstrap: BsBook
  },
  'bitcoin-domains': { 
    lucide: LucideGlobe, 
    'react-icons': MdLanguage,
    tabler: TablerWorld,
    heroicons: HeroGlobe,
    feather: FeatherGlobe,
    phosphor: PhosphorGlobe,
    remix: RiGlobalLine,
    bootstrap: BsGlobe
  },
  'bitcoin-3d': { 
    lucide: LucideBox, 
    'react-icons': MdViewInAr,
    tabler: TablerBox,
    heroicons: HeroBox,
    feather: FeatherBox,
    phosphor: PhosphorBox,
    remix: RiInboxLine,
    bootstrap: BsBox
  },
  'bitcoin-jobs': { 
    lucide: LucideBriefcase, 
    'react-icons': MdWork,
    tabler: TablerBriefcase,
    heroicons: HeroBriefcase,
    feather: FeatherBriefcase,
    phosphor: PhosphorBriefcase,
    remix: RiBriefcaseLine,
    bootstrap: BsBriefcase
  },
  'bitcoin-paint': { 
    lucide: LucidePalette, 
    'react-icons': MdPalette,
    tabler: TablerPalette,
    heroicons: HeroPalette,
    feather: FeatherPalette,
    phosphor: PhosphorPalette,
    remix: RiPaletteLine,
    bootstrap: BsPalette
  },
  'bapps-store': { 
    lucide: LucideStore, 
    'react-icons': MdStore,
    tabler: TablerStore,
    heroicons: HeroStore,
    feather: FeatherStore,
    phosphor: PhosphorStore,
    remix: RiStoreLine,
    bootstrap: BsShop
  },
  'bitcoin-education': { 
    lucide: LucideGraduationCap, 
    'react-icons': MdSchool,
    tabler: TablerSchool,
    heroicons: HeroAcademicCap,
    feather: FeatherAward,
    phosphor: PhosphorGraduationCap,
    remix: RiGraduationCapLine,
    bootstrap: BsMortarboard
  },
  'bitcoin-identity': { 
    lucide: LucideUserCheck, 
    'react-icons': MdVerifiedUser,
    tabler: TablerUserCheck,
    heroicons: HeroUserCheck,
    feather: FeatherUserCheck,
    phosphor: PhosphorUserCheck,
    remix: RiUserAddLine,
    bootstrap: BsPersonCheck
  },
  
  // Desktop icons (simplified names)
  'wallet': { 
    lucide: LucideWallet, 
    'react-icons': MdAccountBalanceWallet,
    tabler: TablerWallet,
    heroicons: HeroWallet,
    feather: FeatherWallet,
    phosphor: PhosphorWallet,
    remix: RiWalletLine,
    bootstrap: BsWallet
  },
  'email': { 
    lucide: LucideMail, 
    'react-icons': MdEmail,
    tabler: TablerMail,
    heroicons: HeroMail,
    feather: FeatherMail,
    phosphor: PhosphorMail,
    remix: RiMailLine,
    bootstrap: BsEnvelope
  },
  'music': { 
    lucide: LucideMusic, 
    'react-icons': MdLibraryMusic,
    tabler: TablerMusic,
    heroicons: HeroMusic,
    feather: FeatherMusic,
    phosphor: PhosphorMusic,
    remix: RiMusic2Line,
    bootstrap: BsMusicNote
  },
  'writer': { 
    lucide: LucideFileText, 
    'react-icons': MdDescription,
    tabler: TablerFileText,
    heroicons: HeroFileText,
    feather: FeatherFileText,
    phosphor: PhosphorFileText,
    remix: RiFileTextLine,
    bootstrap: BsFileText
  },
  'drive': { 
    lucide: LucideHardDrive, 
    'react-icons': MdStorage,
    tabler: TablerDatabase,
    heroicons: HeroDatabase,
    feather: FeatherHardDrive,
    phosphor: PhosphorHardDrives,
    remix: RiHardDriveLine,
    bootstrap: BsHddStack
  },
  'calendar': { 
    lucide: LucideCalendar, 
    'react-icons': MdCalendarToday,
    tabler: TablerCalendar,
    heroicons: HeroCalendar,
    feather: FeatherCalendar,
    phosphor: PhosphorCalendar,
    remix: RiCalendarLine,
    bootstrap: BsCalendar
  },
  'exchange': { 
    lucide: LucideTrendingUp, 
    'react-icons': MdShowChart,
    tabler: TablerChartLine,
    heroicons: HeroChartBar,
    feather: FeatherActivity,
    phosphor: PhosphorChartLine,
    remix: RiLineChartLine,
    bootstrap: BsGraphUp
  },
  'spreadsheet': { 
    lucide: LucideTable, 
    'react-icons': MdTableChart,
    tabler: TablerTable,
    heroicons: HeroTable,
    feather: FeatherTable,
    phosphor: PhosphorTable,
    remix: RiTableLine,
    bootstrap: BsTable
  },
  'search': { 
    lucide: LucideSearch, 
    'react-icons': MdSearch,
    tabler: TablerSearch,
    heroicons: HeroSearch,
    feather: FeatherSearch,
    phosphor: PhosphorSearch,
    remix: RiSearchLine,
    bootstrap: BsSearch
  },
  'identity': { 
    lucide: LucideUserCheck, 
    'react-icons': MdVerifiedUser,
    tabler: TablerUserCheck,
    heroicons: HeroUserCheck,
    feather: FeatherUserCheck,
    phosphor: PhosphorUserCheck,
    remix: RiUserAddLine,
    bootstrap: BsPersonCheck
  },
  'jobs': { 
    lucide: LucideBriefcase, 
    'react-icons': MdWork,
    tabler: TablerBriefcase,
    heroicons: HeroBriefcase,
    feather: FeatherBriefcase,
    phosphor: PhosphorBriefcase,
    remix: RiBriefcaseLine,
    bootstrap: BsBriefcase
  },
  'video': { 
    lucide: LucideVideo, 
    'react-icons': MdVideoLibrary,
    tabler: TablerVideo,
    heroicons: HeroVideo,
    feather: FeatherVideo,
    phosphor: PhosphorVideo,
    remix: RiVideoLine,
    bootstrap: BsCameraVideo
  },
  'education': { 
    lucide: LucideGraduationCap, 
    'react-icons': MdSchool,
    tabler: TablerSchool,
    heroicons: HeroAcademicCap,
    feather: FeatherAward,
    phosphor: PhosphorGraduationCap,
    remix: RiGraduationCapLine,
    bootstrap: BsMortarboard
  },
  'code': { 
    lucide: LucideCode2, 
    'react-icons': MdCode,
    tabler: TablerCode,
    heroicons: HeroCode,
    feather: FeatherCode,
    phosphor: PhosphorCode,
    remix: RiCodeLine,
    bootstrap: BsCode
  },
  'paint': { 
    lucide: LucidePalette, 
    'react-icons': MdPalette,
    tabler: TablerPalette,
    heroicons: HeroPalette,
    feather: FeatherPalette,
    phosphor: PhosphorPalette,
    remix: RiPaletteLine,
    bootstrap: BsPalette
  },
  'domains': { 
    lucide: LucideGlobe, 
    'react-icons': MdLanguage,
    tabler: TablerWorld,
    heroicons: HeroGlobe,
    feather: FeatherGlobe,
    phosphor: PhosphorGlobe,
    remix: RiGlobalLine,
    bootstrap: BsGlobe
  },
  '3d': { 
    lucide: LucideBox, 
    'react-icons': MdViewInAr,
    tabler: TablerBox,
    heroicons: HeroBox,
    feather: FeatherBox,
    phosphor: PhosphorBox,
    remix: RiInboxLine,
    bootstrap: BsBox
  },
  'photos': { 
    lucide: LucideCamera, 
    'react-icons': MdPhotoCamera,
    tabler: TablerCamera,
    heroicons: HeroCamera,
    feather: FeatherCamera,
    phosphor: PhosphorCamera,
    remix: RiCameraLine,
    bootstrap: BsCamera
  },
  'maps': { 
    lucide: LucideMapPin, 
    'react-icons': MdLocationOn,
    tabler: TablerMapPin,
    heroicons: HeroMapPin,
    feather: FeatherMapPin,
    phosphor: PhosphorMapPin,
    remix: RiMapPinLine,
    bootstrap: BsGeoAlt
  },
  'chat': { 
    lucide: LucideMessageCircle, 
    'react-icons': MdChat,
    tabler: TablerMessage,
    heroicons: HeroMessage,
    feather: FeatherMessageCircle,
    phosphor: PhosphorChat,
    remix: RiMessage2Line,
    bootstrap: BsChatDots
  },
  'social': { 
    lucide: LucideUsers, 
    'react-icons': MdGroup,
    tabler: TablerUsers,
    heroicons: HeroUsers,
    feather: FeatherUsers,
    phosphor: PhosphorUsers,
    remix: RiGroupLine,
    bootstrap: BsPeople
  },
  'games': { 
    lucide: LucideGamepad2, 
    'react-icons': MdSportsEsports,
    tabler: TablerGamepad,
    heroicons: HeroGamepad,
    feather: FeatherGamepad,
    phosphor: PhosphorGamepad,
    remix: RiGamepadLine,
    bootstrap: BsController
  },
  'books': { 
    lucide: LucideBookOpen, 
    'react-icons': MdMenuBook,
    tabler: TablerBook,
    heroicons: HeroBookOpen,
    feather: FeatherBookOpen,
    phosphor: PhosphorBookOpen,
    remix: RiBookOpenLine,
    bootstrap: BsBook
  },
  'settings': {
    lucide: LucideSettings,
    'react-icons': MdSettings,
    tabler: TablerSettings,
    heroicons: HeroSettings,
    feather: FeatherSettings,
    phosphor: PhosphorSettings,
    remix: RiSettings3Line,
    bootstrap: BsGear
  },
  'terminal': {
    lucide: LucideTerminal,
    'react-icons': MdTerminal,
    tabler: TablerTerminal,
    heroicons: HeroTerminal,
    feather: FeatherTerminal,
    phosphor: PhosphorTerminal,
    remix: RiTerminalLine,
    bootstrap: BsTerminal
  },
  'home': {
    lucide: LucideCircle,
    'react-icons': MdCircle,
    tabler: TablerCircle,
    heroicons: HeroCircle,
    feather: FeatherCircle,
    phosphor: PhosphorCircle,
    remix: RiCircleLine,
    bootstrap: BsCircle
  },
  'bitcoin-os': {
    lucide: LucideMonitor,
    'react-icons': MdMonitor,
    tabler: LucideMonitor,
    heroicons: LucideMonitor,
    feather: LucideMonitor,
    phosphor: LucideMonitor,
    remix: LucideMonitor,
    bootstrap: LucideMonitor
  },
  'cms': {
    lucide: LucideEdit,
    'react-icons': LucideEdit,
    tabler: LucideEdit,
    heroicons: LucideEdit,
    feather: LucideEdit,
    phosphor: LucideEdit,
    remix: LucideEdit,
    bootstrap: LucideEdit
  }
}

export const getCompleteThemedIcon = (iconId: string, theme: string = 'lucide') => {
  const mapping = completeIconMappings[iconId]
  if (!mapping) {
    // Fallback to default settings icon
    const defaultMapping = completeIconMappings['settings']
    return defaultMapping[theme as keyof CompleteIconMapping] || defaultMapping.lucide
  }
  
  return mapping[theme as keyof CompleteIconMapping] || mapping.lucide
}